export enum EnumProgramRetailerStatusString {
  ACTIVE = 'Aktif',
  SUBMITTED = 'Diajukan',
  NEED_CHANGED = 'Butuh Perbaikan',
  EXTEND_PERIOD = 'Pengajuan Perpanjangan',
  SCHEDULED = 'Dijadwalkan',
  FINISHED = 'Selesai',
  CANCELED = 'Dibatalkan',
}

export enum EnumProgramRetailerStatusEnum {
  ACTIVE = 'ACTIVE',
  SUBMITTED = 'SUBMITTED',
  NEED_CHANGED = 'NEED_CHANGED',
  EXTEND_PERIOD = 'EXTEND_PERIOD',
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
}

export enum EnumProgramRetailerTargetScanType {
  // VOLUME, PRICE_NOMINAL, QTY_QR
  QTY_QR = 'QTY_QR',
  PRICE_NOMINAL = 'PRICE_NOMINAL',
  VOLUME = 'VOLUME',
}
export enum EnumProgramRetailerTargetScanTypeString {
  QTY_QR = 'Jumlah QR',
  PRICE_NOMINAL = 'Nominal (Rupiah)',
  VOLUME = 'Volume/Tonase (L/Kg)',
}

// NON_MAI_PRODUCT, MAI_PRODUCT
export enum EnumProgramRetailerRewardType {
  NON_MAI_PRODUCT = 'PRODUCT_NON_MAI',
  MAI_PRODUCT = 'PRODUCT_MAI',
}

export enum EnumProgramRetailerSection {
  PROGRAM_INFORMATION = 'PROGRAM_INFORMATION',
  PROGRAM_TERM = 'PROGRAM_TERM',
  TARGET_SCAN_TERM = 'TARGET_SCAN_TERM',
  PRODUCT_SCAN_TERM = 'PRODUCT_SCAN_TERM',
  REWARD_TERM = 'REWARD_TERM',
}

export enum EnumProgramMarketingRewardRule {
  MULTIPLES = 'MULTIPLES',
  NOT_MULTIPLES = 'NOT_MULTIPLES',
}

export enum EnumProgramMarketingRewardRuleString {
  MULTIPLES = 'Berlaku Kelipatan',
  NOT_MULTIPLES = 'Tidak Berlaku Kelipatan',
}

export enum EnumProgramMarketingScanRule {
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  ACCUMULATION_PRODUCTS = 'ACCUMULATION_PRODUCTS',
}
export enum EnumProgramMarketingScanRuleString {
  ALL_PRODUCTS = 'Seluruh Produk',
  ACCUMULATION_PRODUCTS = 'Akumulasi/Gabungan Produk',
}

export enum EnumProgressFilter {
  COMPLETE = 'COMPLETE',
  ONGOING = 'ONGOING',
  RECURRING_COMPLETION = 'RECURRING_COMPLETION',
}

export enum EnumRewardType {
  NON_MAI = 'PRODUCT_NON_MAI',
  MAI = 'PRODUCT_MAI',
}

export enum EnumRewadBudget {
  ESTIMATE = 'ESTIMATE',
  DISBURSEMENT = 'DISBURSEMENT',
  ISMULTILEVEL = 'ISMULTILEVEL',
}

export enum EnumRewadBudgetString {
  ESTIMATE = 'Estimasi Budget Hadiah Program',
  DISBURSEMENT = 'Budget Pencairan Hadiah Program',
}

export enum EnumScanTerm {
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  ACCUMULATION_PRODUCTS = 'ACCUMULATION_PRODUCTS',
}

export enum EnumScanTermString {
  ALL_PRODUCTS = 'Semua Produk',
  ACCUMULATION_PRODUCTS = 'Akumulasi/Gabungan Produk',
}

export enum EnumScopeProgramTerm {
  AREA = 'AREA',
  SUB_AREA = 'SUB_AREA',
  NATIONAL = 'NATIONAL',
}
